import React, {useState} from 'react';
import {AddContainer} from './style';

export const AddButton = (props) => {
	const [active] = useState(false);
	const {title, onClick} = props;

  return (
    <AddContainer
      status={active}
      hasShadow={props.hasShadow}
      expand={props.expand}
      disable={props.disable}
      style={props.style}
    >      
      <div className={`add-button`}>        
        <div className="button-text" onClick={onClick}>
          <i className="icon mapsa-plus"> </i>
          <span className="add-button-text no-select">{title}</span>          
        </div>
      </div>
    </AddContainer>
  );
};